export default {
  前往查看: 'Go to view',
  您的真实姓名: 'Your real name',
  申请成为子账号: 'Apply to be a sub-account',
  企业联系人: 'Corporate Contact',
  企业管理者联系信息: 'Business Administrator Contact Information',
  企业认证提示1:
    'Improve the multilingual version of the enterprise, you can get more foreign procurement consulting opportunities!',
  企业名称不能为空: 'Enterprise name cannot be empty',
  企业名称最多输入120个字符: 'Enter up to 120 characters for your business name',
  请填写企业名称: 'Please fill in the name of the company',
  企业认证提示2:
    'The format is JPG/PNG, the map is recommended to be white or transparent, the size of the length and width is at least 300px, and the size is within 5M',
  logo不能为空: 'logo cannot be empty',
  企业认证提示3:
    'Please upload a business license registered with the relevant government agency, such as a business license in China',
  企业营业执照不能为空: 'Enterprise business license can not be empty',
  企业认证提示4: 'Company profile, up to 2000 characters',
  企业简介不能为空: 'Company profile cannot be empty',
  姓名不能为空: 'Name cannot be empty',
  请填写姓名: 'Please fill in your name',
  企业认证提示6: '1、Up to 15 pure digits for cell phone numbers and up to 20 characters for fixed-line calls.',
  企业名称最多输入30个字符: 'Enter up to 30 characters for your business name',
  企业简介最多输入2000个字符: 'Enter up to 2000 characters in your company',
  联系方式不能为空: 'Contact information cannot be empty',
  邮箱不能为空: 'Mailbox cannot be empty',
  邮箱格式错误: 'Mailbox format error',
  邮箱最多输入60个字符: 'Enter up to 60 characters for mailboxes',
  职务最多输入45个字符: 'Enter up to 45 characters for the position',
  企业认证提示5:
    'Enterprise manager, refers to the direct person in charge of the enterprise, the account has the highest management authority of the enterprise, such as enterprise content publishing, sub-account employee management, enterprise data query, etc. The identity of the enterprise manager cannot be transferred, please submit your application for certification carefully!',
  企业认证提示7:
    '2、Cell phone number or landline phone can be one of two options, at least one of the contact information.',
  企业认证提示8:
    'The platform will review for you as soon as possible. Please improve your enterprise cloud exhibition system after passing the review',
  企业认证提示9:
    'You can also scan the code to download the official App or directly open the WeChat app to follow more',
  或点击返回会员中心: 'Or click back to Member Center',
  后: 'after',
  请输入手机号: 'Please enter your cell phone number',
  请输入固定电话: 'Please enter a landline phone number',
  文件大小不能超过5M: 'File size cannot exceed 5M',
  温馨提示: 'Warm Tips',
  上传图片: 'Upload images',
  企业认证申请提示: 'Enterprise certification application tips',
  企业认证提示10:
    '1、After the successful submission of the application for the corporate role, the platform will be audited in 1-3 working days, and the audit result will be notified by intranet message, please pay attention.',
  企业认证提示11:
    '2、Enterprise information-related content is prohibited to publish illegal and undesirable information involving politics, pornography, violence, vulgarity, etc. Once found, the platform will have the right to freeze your account and retain the right to pursue legal responsibility.',
  企业认证提示12:
    '3、Companies can choose to supplement the translated content with other language versions, supporting Simplified Chinese (default) and English, according to their needs for different markets and themselves.',
  企业认证提示13:
    '4、Cloud show power platform supports multi-language environment, it is recommended that when enterprises improve their corporate information, they should also improve the multi-language version to help overseas buyers browse and consult.',
}
